import App from './App'
import render from 'commons/js/util/render'
import { init as initReporter } from 'commons/js/util/reporter'
initReporter()

const selector = '.js-login-form-content'
const element = document.querySelector(selector)
const dataset = element.dataset
const params = new URLSearchParams(document.location.search)

const datasetProps = {
    redirect: dataset['redirect'] || null,
    initialView: dataset['initialview'],
}

const urlParamsProps = {
    promoCode: params.get('promotional_code'),
}

render({ App, element, props: { ...datasetProps, ...urlParamsProps } })
